import { useTranslation } from 'react-i18next';

function CompanyLogo({ logoUrl }: { logoUrl?: string }) {
  const { t } = useTranslation();

  return logoUrl ? <img src={logoUrl} alt={t('companyLogoDash')} /> : <div />;
}

export default CompanyLogo;
